import { queryConfig } from './queryConfig';

export interface User {
  uid: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  status: string;
  remarks: string | null;
  created_at: string;
}

const query = queryConfig({});

export const useGetUsers = (params?: { page?: number; limit?: number; q?: string }) =>
  query<{ page: number; limit: number; total: number; users: User[] }>({
    url: '/v1/ops/users',
    cacheKey: 'users',
    params,
  });
